// extracted by mini-css-extract-plugin
export default {"container":"Console_container__Jhb42","message":"Console_message__YlNQX","submessage":"Console_submessage__lhSuZ","status":"Console_status__Rmad3","text":"Console_text__efV+B"};